import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../environments/environment';

export interface RegisterUserData {
  name:string,
  surname: string,
  password: string,
  password_confirm: string,
}

@Injectable({
  providedIn: 'root'
})
export class RegisterUserService {

  constructor(
    public http: HttpClient,
    private authService: AuthService,
    private router: Router
  ) {
  }

  validateToken(token: string){
    const endpoint = environment.apiUrl + "/api/invitations/validate/" + token;

    return this.http.get(endpoint)
  }

  createUser(token:string, userData: RegisterUserData) {
    const endpoint = environment.apiUrl + "/api/invitations/accept/" + token;

    return this.http.post(endpoint, 
      {
        "name": userData.name,
        "surname": userData.surname,
        "password": userData.password,
        "password_confirmation": userData.password_confirm
      }
    )
  }
}
